/* ErgoVia Health cart upsell - fed by Shopify's own recommendations, no fabricated data */
(function () {
  'use strict';
  var state = { recs: [], idx: 0, busy: false };
  var debounceTimer = null;

  function cents(x) {
    if (typeof x === 'number') return Math.round(x);
    if (typeof x === 'string') return x.indexOf('.') > -1 ? Math.round(parseFloat(x) * 100) : parseInt(x, 10);
    return 0;
  }
  function money(x) { return '$' + (cents(x) / 100).toFixed(2); }
  function imgUrl(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=180'; }
  function box() { return document.getElementById('CartUpsell'); }

  async function fetchCart() { return (await fetch('/cart.js')).json(); }

  async function fetchRecs(productId, inCart) {
    var recs = [];
    /* 1. Same collection as the cart's first item — keeps suggestions on-category.
          Shopify's own algorithm pulls unrelated items on a mixed catalog. */
    var b = box();
    var handles = ((b && b.dataset.collections) || '').split(',').filter(Boolean);
    for (var i = 0; i < handles.length && !recs.length; i++) {
      try {
        var rc = await fetch('/collections/' + handles[i] + '/products.json?limit=20');
        if (rc.ok) {
          recs = ((await rc.json()).products || []).filter(function (p) {
            return !inCart.has(p.id) && p.variants && p.variants.some(function (v) { return v.available; });
          });
        }
      } catch (e) { /* try next handle */ }
    }
    if (recs.length) return recs;
    try {
      var r = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related');
      if (r.ok) recs = (await r.json()).products || [];
    } catch (e) { /* fall through */ }
    recs = recs.filter(function (p) { return !inCart.has(p.id) && p.available; });
    if (recs.length) return recs;
    try {
      var r2 = await fetch('/collections/all-products/products.json?limit=24');
      if (r2.ok) recs = ((await r2.json()).products || []).filter(function (p) {
        return !inCart.has(p.id) && p.variants && p.variants.some(function (v) { return v.available; });
      });
    } catch (e) { /* ignore */ }
    return recs;
  }

  function render() {
    var b = box(); if (!b || !state.recs.length) return;
    var p = state.recs[state.idx];
    var img = b.querySelector('.cart-upsell__img');
    var imglink = b.querySelector('.cart-upsell__imglink');
    var title = b.querySelector('.cart-upsell__title');
    var price = b.querySelector('.cart-upsell__price');
    var add = b.querySelector('.cart-upsell__add');
    var url = p.url || ('/products/' + p.handle);
    /* image shape differs per endpoint: recommendations = string, collection JSON = {src} object */
    var raw = p.featured_image || (p.images && p.images[0]) || '';
    var image = typeof raw === 'string' ? raw : (raw && raw.src) || '';
    img.src = imgUrl(image);
    img.alt = p.title;
    imglink.href = url;
    title.textContent = p.title;
    title.href = url;
    var basePrice = p.price != null ? p.price : (p.variants && p.variants[0] && p.variants[0].price);
    price.textContent = money(basePrice);
    var avail = (p.variants || []).filter(function (v) { return v.available !== false; });
    var sel = b.querySelector('.cart-upsell__variant');
    if (!avail.length) { add.textContent = 'View'; add.onclick = function () { window.location.href = url; }; if (sel) sel.hidden = true; }
    else if (avail.length === 1) {
      if (sel) sel.hidden = true;
      add.textContent = 'Add';
      add.onclick = function () { addToCart(avail[0].id, add); };
    } else {
      sel.innerHTML = avail.map(function (v) {
        return '<option value="' + v.id + '" data-price="' + cents(v.price) + '">' + String(v.title).replace(/</g, '&lt;') + '</option>';
      }).join('');
      sel.hidden = false;
      sel.onchange = function () {
        var o = sel.options[sel.selectedIndex];
        price.textContent = money(parseInt(o.getAttribute('data-price'), 10));
      };
      add.textContent = 'Add';
      add.onclick = function () { addToCart(parseInt(sel.value, 10), add); };
    }
    var prev = b.querySelector('[data-dir="-1"]');
    var next = b.querySelector('[data-dir="1"]');
    prev.disabled = state.recs.length < 2;
    next.disabled = state.recs.length < 2;
    prev.onclick = function () { state.idx = (state.idx - 1 + state.recs.length) % state.recs.length; render(); };
    next.onclick = function () { state.idx = (state.idx + 1) % state.recs.length; render(); };
  }

  async function addToCart(variantId, btn) {
    if (state.busy) return;
    state.busy = true;
    if (btn) { btn.textContent = '...'; btn.disabled = true; }
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (r.ok) await refreshDrawerSections();
    } finally {
      state.busy = false;
      if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
    }
  }

  async function refreshDrawerSections() {
    var r = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
    var data = await r.json();
    var parse = function (html, sel) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    };
    var drawer = document.getElementById('CartDrawer');
    var nd = parse(data['cart-drawer'], '#CartDrawer');
    if (drawer && nd) drawer.innerHTML = nd.innerHTML;
    var bubble = document.getElementById('cart-icon-bubble');
    var nb = parse(data['cart-icon-bubble'], '.shopify-section');
    if (bubble && nb) bubble.innerHTML = nb.innerHTML;
    refresh();
  }

  async function refresh() {
    var b = box(); if (!b) return;
    try {
      var cart = await fetchCart();
      var bar = document.querySelector('.cart-shipbar');
      if (!cart.items.length) { b.hidden = true; if (bar) bar.style.display = 'none'; return; }
      if (bar) bar.style.display = '';
      var inCart = new Set(cart.items.map(function (i) { return i.product_id; }));
      var recs = await fetchRecs(cart.items[0].product_id, inCart);
      if (!recs.length) { b.hidden = true; return; }
      state.recs = recs.slice(0, 8);
      if (state.idx >= state.recs.length) state.idx = 0;
      render();
      b.hidden = false;
    } catch (e) { b.hidden = true; }
  }

  function schedule() { clearTimeout(debounceTimer); debounceTimer = setTimeout(refresh, 200); }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    new MutationObserver(function (muts) {
      var b = box();
      var external = muts.some(function (m) { return !b || !b.contains(m.target); });
      if (external) schedule();
    }).observe(drawer, { childList: true, subtree: true });
    refresh();
  });
})();
